export default "__VITE_ASSET__DVSt5u8X__"